import { type ListAction, ListActions, type ListState } from './listReducer.ts';

export const dispatchListData = (payload: Omit<ListState, 'loadingList'>, dispatch: React.Dispatch<ListAction>) => {
  dispatch({
    payload,
    type: ListActions.SET_LIST_DATA,
  });
};
